<template>
  <div v-wechat-title="$store.state.html_title || $route.meta.title">
    <Panel :class="{'on': on }" v-show="no_header" @change="change"></Panel>
    <Header :class="{'on': on }" v-show="no_header" @change="change" :on="on"></Header>
    <!-- <div class="dwapp-container">
      <div class="intel-header">
        <img src="https://static-cdn-test.vcbeat.top/vbdata-ssr/pic/appH5/h5logo.png">
        <p>下载动脉网APP发现更多产业信息！</p>
        <Button type="primary" shape="circle" @click="goApp">{{isiOS ? 'APP内打开' : '前往下载'}}</Button>
      </div>
      <Button type="primary" shape="circle" @click="goApp" class="btm-btn" v-if="isiOS">动脉网APP内打开</Button>
    </div> -->
    <div class="container" :class="{'on': on, 'no-header': !no_header }">
      <keep-alive>
        <router-view :key="activeDate" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view :key="activeDate" v-if="!$route.meta.keepAlive" />
    </div>
    <Modal v-model="fill_adv_status" v-if="fill_banner_list.length" :scrollable="true" :footer-hide="true" class-name="fill-adv-modal" width="auto">
      <a @click="globalClickBanner(fill_banner_list[0])" class="fill-adv-image">
        <img :src="fill_banner_list[0].img" :title="fill_banner_list[0].description">
      </a>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment'
import Cookies from 'js-cookie'
import { user_mixin } from 'mobile/js/user_mixin'
import { createThemeTypeOrder } from './service'
import { Aadvertisement, Ainsertrecords } from '@/service'
import Header from '@/views/Mobile/components/header.vue'
import Panel from '@/views/Mobile/components/panel.vue'
const no_header_list = [
  'MNotFound',
  'MNewsList',
  'MNewsDetail',
  'MAttentionIndex',
  'MOrgDetail',
  'MCompanyDetail',
  'MCompanyCompare',
  'MPeoDetail',
  'MFinancingIndex',
  'MShareTimeLine',
  'MBriefReport',
  'MSanten',
  'MNewsletter',
  'MEventList',
  'MMergersList',
  'MCompanyList',
  'MOrgList',
  'MHospitalList',
  'MHospitalDetail',
  'MPolicyList',
  'MSearchList',
  'MReportList',
  'MReportDetail',
  'MUserReport',
  'MOrderList',
  'MOpenInv',
  'MBuyVip',
  'MUserAccount',
  'MNotOpen',
  'MUserMain',
  'MPreviewBriefReport',
  'MShareMap',
  'MShareTable',
  'MShareScatter',
  'MCollectInfo',
  'MPayStatus',
  'MBuyInfo',
  'MLogin',
  'MLogin2',
  'VipExperience',
  'MExperienceSuccess',
  'MShareScatterWx',
  'MShareMapWx',
  'MShareTimeLineWx',
  'MShareTableWx',
  'MIndex',
  'MLog',
  'MHelpCenter',
  'MAbout',
  'MWorkBench',
  'MFeedList',
  'contact',
  'MApplyTest',
  'MApplySuccess',
  'MSearchNewsletter',
  'MEnNewsletter',
  'MEnSearchNewsletter'
]
export default {
  mixins: [user_mixin],
  provide() {
    return {
      reload: this.reload,
      goBuy: this.goBuy,
    }
  },
  data() {
    return {
      activeDate: moment().unix(),
      on: false,
      order_actions: {
        theme_type_id: createThemeTypeOrder,
      },
      fill_adv_status: false,
      fill_banner_list: [],
      isiOS: false,
    }
  },
  computed: {
    no_header: function () {
      // 页面是否需要header
      // console.log(this.$route)
      return no_header_list.indexOf(this.$route.name) == -1 ? true : false
    },
  },
  components: {
    Header,
    Panel,
  },
  methods: {
    goApp() {
      if (this.isiOS) {
        window.location.href = 'https://app.vbdata.cn/dongmai/'
      } else {
        window.location.href = 'https://www.vbdata.cn/mobile/downloadApp?source=H5动脉橙'
      }
    },
    reload(cb) {
      this.activeDate = moment().unix()
      this.$nextTick(() => {
        if (cb) {
          cb
        }
      })
    },
    change() {
      // 是否显示抽屉
      this.on = !this.on
    },
    // 是否执行购买流程(create_order_key:创建订单需要的key，create_order_value:创建订单需要的value,buy_type:购买类型,url：购买回调地址)
    async goBuy(create_order_key, create_order_value, buy_type, url) {
      if (this.$store.state.user_key) {
        if (!this.user.name || !this.user.compName || !this.user.title) {
          // 去完善信息
          // this.$router.push({name: 'MCollectInfo',query: {[create_order_key]: create_order_value, type: buy_type, url: Buffer(url).toString('base64')}})
          this.$router.push({
            name: 'MCollectInfo',
            query: { [create_order_key]: create_order_value, type: buy_type, url: escape(url) },
          })
        } else {
          //  去订单详情
          let res = await this.order_actions[create_order_key]({
            user_key: this.$store.state.user_key,
            [create_order_key]: create_order_value,
          })
          if (res.status == 'success') {
            // this.$router.push({name: 'MBuyInfo',params: {order_uid: res.order_uid, type: buy_type}, query: { url: Buffer(url).toString('base64')}})
            this.$router.push({
              name: 'MBuyInfo',
              params: { order_uid: res.order_uid, type: buy_type },
              query: { url: escape(url) },
            })
          } else {
            this.$Message.error(res.message)
          }
        }
      } else {
        //  去登录
        // this.$router.push({name: 'MLogin',query: {action: 'buy', [create_order_key]: create_order_value, type: buy_type, url: Buffer(url).toString('base64')}})
        this.$router.push({
          name: 'MLogin',
          query: {
            action: 'buy',
            [create_order_key]: create_order_value,
            type: buy_type,
            url: escape(url),
          },
        })
      }
    },
    globalClickBanner(item) {
      this.insertRecords(item)
      if (item.jumpType == 0) {
        return
      } else if (item.jumpType == 1) {
        window.location.href = item.jumpOrientation.pointUrl
      } else {
        let href = this.$store.state.index2_path + '/mobile/downloadApp'
        window.location.href = href
      }
    },
    async insertRecords(item, viewType = 1) {
      let createTime = moment().format('YYYY-MM-DD HH:mm:ss')
      let params_arr = [
        {
          contentId: item.appAdScheduleId,
          contentType: '45',
          createTime: createTime,
          enterType: '23',
          imei: this.$store.state.uUid,
          loginPlatform: '1',
          viewType: viewType,
          xuserid: this.$store.state.uUserId,
        },
      ]
      let res = await Ainsertrecords({
        appAccessRecords: params_arr,
      })
    },
    async getHomeBanner() {
      let res = await Aadvertisement({ appAdPositionIds: [35] })
      if (res.code == 0) {
        this.fill_banner_list = [...res.data]

        if (!this.fill_banner_list.length) return
        // 使用Moment.js获取当前日期并格式化为'YYYYMMDD'
        const current_date_str = moment().format('YYYYMMDD')
        // 检查cookie是否存在以及其值是否为当前日期
        const shouldUpdateCookie =
          !Cookies.get('open_fill_date') || Cookies.get('open_fill_date') != current_date_str
        // 如果需要更新cookie，则设置fill_adv_status为true并更新cookie的值
        if (shouldUpdateCookie) {
          this.fill_adv_status = true
          this.insertRecords(this.fill_banner_list[0], 2)
          Cookies.set('open_fill_date', current_date_str, {
            domain: this.$store.state.domain_path,
            path: '/',
            expires: this.$store.state.oneYearFromNow
          })
        }
      }
    },
  },
  created() {
    this.getHomeBanner()
  },
  mounted() {
    const u = navigator.userAgent
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
  },
}
</script>
<style lang="stylus">
@import '../../assets/mobile/styles/common.stylus'
.container
  padding-top 1rem
  transition all 0.3s
  -webkit-overflow-scrolling touch
  &.on
    transform translateX(-3.2rem)
  &.no-header
    padding-top 0
.fill-adv-modal
  display flex
  align-items center
  justify-content center
  .ivu-modal
    top 0
    width calc(100vw - 30px) !important
    .ivu-modal-close
      .ivu-icon-ios-close
        font-size 25px
        background rgba(255, 255, 255, 0.4)
        border-radius 50%
        color #FFF
        position relative
        display flex
        align-items center
        justify-content center
        top 0
        transition all 0.2s
        &:hover
          background rgba(255, 255, 255, 0.5)
    .ivu-modal-content
      border-radius 0
      background-color transparent
      box-shadow none
    .ivu-modal-body
      padding 0
      font-size 0
      line-height 1
    .fill-adv-image
      display block
      img
        width 100%
.dwapp-container
  height 1rem
  .btm-btn
    position fixed
    bottom 90px
    left 50%
    transform translateX(-50%)
    z-index 100
  .intel-header
    position fixed
    height 1rem
    top 1rem
    width 100%
    background #FFFFFF
    padding 0.2rem
    box-shadow 0rem 0.06rem 0.22rem 0rem rgba(101, 122, 147, 0.2)
    display flex
    align-items center
    justify-content space-between
    z-index 100
    img
      width 0.6rem
    p
      font-size 0.28rem
      font-weight bold
      color #1D2129
  .ivu-btn-primary
    background-color #FA5A00
    border-color #FA5A00
    &:hover
      border-color #FA5A00
      background-color #FA5A00
</style>
